import apiService from './api';

export interface Document {
  id: number;
  name: string;
  original_name: string;
  file_url: string;
  file_size: number;
  file_type: string;
  uploaded_by: string;
  created_at: string;
  updated_at: string;
}

export interface UploadDocumentRequest {
  file: File;
  name: string;
}

export const documentService = {
  // Get all documents
  getDocuments: async (): Promise<Document[]> => {
    const response = await apiService.get<Document[]>('/documents');
    console.log("response_doc:::::::;;", response)
    return response.data;
  },

  // Upload a new document
  uploadDocument: async (formData: FormData): Promise<Document> => {
    const response = await apiService.post<Document>('/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete a document
  deleteDocument: async (id: number): Promise<void> => {
    await apiService.delete(`/documents/${id}`);
  },

  // Get document by ID
  getDocument: async (id: number): Promise<Document> => {
    const response = await apiService.get<Document>(`/documents/${id}`);
    return response.data;
  },

  // Update document name
  updateDocument: async (id: number, name: string): Promise<Document> => {
    const response = await apiService.put<Document>(`/documents/${id}`, { name });
    return response.data;
  },
}; 